import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatchService } from '../match.service';
import swal from "sweetalert2";
import { Router } from '@angular/router';

@Component({
  selector: 'app-add-manual-match',
  templateUrl: './add-manual-match.component.html',
  styleUrls: ['./add-manual-match.component.css']
})
export class AddManualMatchComponent implements OnInit {
  matchForm: FormGroup;
  type: any;
  isLoading = false;
  runnerToggle: Boolean;
  testToggle: Boolean;
  submitted = false;
  constructor(private formBuilder: FormBuilder, private matchService: MatchService,
    private router: Router) { }

  ngOnInit(): void {
    this.runnerToggle = false;
    this.testToggle = false;
    this.matchForm = this.formBuilder.group({
      eventId: ['', [Validators.required]],
      marketId: ['', [Validators.required]],
      eventName: ['', [Validators.required]],
      matchType: ['', [Validators.required]],
      openDate: ['', [Validators.required]],
      runner1: ['', [Validators.required]],
      runner2: ['', [Validators.required]],
      runner3: ['0', [Validators.required]],
    });
  }

  get f() { return this.matchForm.controls; }

  onSubmit() {
    this.submitted = true;
    this.isLoading = true;
    if (this.matchForm.invalid) {
      this.isLoading = false;
      return false;
    }

    this.matchService.addManualMatch(this.matchForm.value).subscribe(data => {
      //console.log(data);
      this.isLoading = false;
      this.msgSuccess();
      this.router.navigate(['/home2']);
    }, error => {
      console.log(error);
      this.isLoading = false;
      this.msgFailure();
    });
  }

  setRunners(type) {
    this.type = type;
    this.runnerToggle = this.type ? true : false;
    this.testToggle = this.type == 'Test' ? true : false;
    this.type == 'Test' ? this.matchForm.patchValue({ runner3: '' }) : this.matchForm.patchValue({ runner3: '0' });
  }

  msgSuccess() {
    swal.fire({
      icon: 'success',
      title: 'Successfully Added!',
      showConfirmButton: false,
      timer: 1500
    })
  }

  msgFailure() {
    swal.fire({
      icon: 'error',
      title: 'Something Went Wrong!',
      showConfirmButton: false,
      timer: 1500
    })
  }
}
